//有關完整的API文件，包括代碼範例，請瀏覽http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});